(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const form = document.getElementById('{{ form_id }}');
    if (!form) return;

    const emailInput = form.querySelector('#ContactForm-email');
    const emailError = form.querySelector('#ContactForm-email-error');
    if (!emailInput || !emailError) return;

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const showError = (message) => {
      emailInput.setAttribute('aria-invalid', 'true');
      emailInput.setAttribute('aria-describedby', 'ContactForm-email-error');
      emailError.textContent = message;
      emailError.hidden = false;
    };

    const clearError = () => {
      emailInput.removeAttribute('aria-invalid');
      emailInput.removeAttribute('aria-describedby');
      emailInput.setCustomValidity('');
      emailError.textContent = '';
      emailError.hidden = true;
    };

    const validateEmailField = () => {
      const value = emailInput.value.trim();

      if (!value) {
        const message = 'Please enter your email address.';
        emailInput.setCustomValidity(message);
        showError(message);
        return false;
      }

      if (!emailPattern.test(value)) {
        const message = 'Please enter a valid email address.';
        emailInput.setCustomValidity(message);
        showError(message);
        return false;
      }

      clearError();
      return true;
    };

    emailInput.addEventListener('input', () => {
      if (emailInput.value.trim() === '' || emailPattern.test(emailInput.value.trim())) {
        clearError();
      }
    });

    emailInput.addEventListener('blur', validateEmailField);

    form.addEventListener('submit', (event) => {
      if (!validateEmailField()) {
        event.preventDefault();
        emailInput.reportValidity();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
